import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
const names = ['Valentina', 'Camila', 'Martina', 'Lucía', 'Sofía', 'Florencia', 'Julieta', 'Agustina', 'Micaela', 'Rocío', 'Antonella', 'Milagros', 'Delfina', 'Catalina', 'Victoria'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Tucumán', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Bariloche'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 10000);
    // Interval for subsequent popups (between 15s and 30s)
    const interval = setInterval(() => {
      showPopup();
    }, Math.random() * 15000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible && !currentBuyer.name) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm surface-gradient border border-gold-dark/30 rounded-lg p-4 shadow-2xl transition-all duration-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'}`} data-id="element-203">
      <div className="flex items-start gap-3" data-id="element-204">
        <div className="bg-mystic-bg p-2 rounded-full border border-gold-dark/50" data-id="element-205">
          <MapPin className="w-5 h-5 text-gold-light" data-id="element-206" />
        </div>
        <div data-id="element-207">
          <p className="text-text-primary font-outfit text-sm" data-id="element-208">
            <span className="font-medium text-gold-light" data-id="element-209">
              {currentBuyer.name}
            </span>{' '}
            de {currentBuyer.city}
          </p>
          <p className="text-text-soft text-xs mt-1" data-id="element-210">
            acaba de comprar el Grimorio del Sur
          </p>
          <p className="text-text-muted text-[10px] mt-1" data-id="element-211">Hace unos segundos</p>
        </div>
      </div>
    </div>;
};